<template>
    <ExtendedLayout
        :user="user"
        currentTab="documents"
    >

        <InertiaLink :href="$route('admin::users.documents.create', { user: user.id })" class="inline-block bg-white shadow rounded-lg py-4 px-8 hover:bg-gray-100 transition-all font-bold">
            {{ __('admin::general.create_model', {'model': __('admin::documents.document').toLowerCase() }) }}
        </InertiaLink>

        <Table
            :headings="[
                __('admin::labels.name'),
                __('admin::labels.type'),
                __('admin::labels.created_at'),
            ]"
            :paginator="paginator"
            :withFilters="false"
        >

            <template #results>
                <tr v-for="document in paginator.data" :key="document.id">
                    <td>{{ document.name }}</td>
                    <td>{{ documentTypeOptions[document.type] }}</td>
                    <td>{{ $datetime(document.created_at) }}</td>
                    <td>
                        <a
                            class="inline-block py-2 px-2 mt-1 hover:bg-gray-100 rounded-lg"
                            :href="$route('admin::users.documents.show', { user: user.id, document: document.id })"
                            target="_blank"
                        >
                            <EyeIcon class="h-4 w-4 text-indigo-500" />
                        </a>
                        <TableButton
                            variant="destroy"
                            @delete="deleting = $route('admin::users.documents.destroy', { user: user.id, document: document.id })"
                        />
                    </td>
                </tr>
            </template>

        </Table>

        <DeleteDialog
            :title="__('admin::general.delete_model', { model: __('admin::documents.document') })"
            :url="deleting"
            v-if="deleting"
            @closed="deleting = null"
        />

    </ExtendedLayout>
</template>

<script>
import ExtendedLayout from '@A/Pages/Users/Edit';
import {EyeIcon} from "@heroicons/vue/solid";

export default {
    components: {
        ExtendedLayout,
        EyeIcon,
    },
    props: {
        errors: Object,
        user: Object,
        paginator: Object,
        documentTypeOptions: Object,
    },
    data() {
        return {
            deleting: null,
        }
    },
}
</script>
